<script>
import options from "./SiteSearching.options"

export default options
</script>

<template>
    <themeSwitch theme="nyk-sparinvest" />

    <article class="nyk-site-searching">
        <div class="nyk-site-searching__content">
            <div class="nyk-site-searching__content__header">
                
                <h1 v-if="isMainHeader" class="nyk-site-searching__content__header__title">
                    {{ labels.searchResultTitleLabel }}
                </h1>

                <h2 v-else class="nyk-site-searching__content__header__title">
                    {{ labels.searchResultTitleLabel }}
                </h2>


                <div 
                    aria-live="polite"    
                    class="nyk-site-searching__content__header__count">
                    
                    <span class="nyk-site-searching__content__header__count__number">{{ unfilteredNumberOfResults }}</span>
                    <span class="nyk-site-searching__content__header__count__text">{{ labels.resultNumberLabel }}</span>
                </div>
            </div>

            <div class="nyk-site-searching__content__list">
                <SearchInputField :initSearchParam="searchInput" :onChangeCallback="inputChanged" :searchInputAriaLabel="labels?.searchInputAriaLabel" :searchButtonAriaLabel="labels?.searchButtonAriaLabel" :searchResetAriaLabel="labels?.searchResetAriaLabel"/>

                <template v-if="searchFacts.length > 0">
                    <div class="nyk-js--facts-container">
                        <FilterTabs :initActiveTab="activeFilter" :tabs="searchFacts" :callback="changeFilter" />
                    </div>
                </template>

                <div class="nyk-site-searching__content__list__results">
                    <template v-for="(result, index) in searchResults">
                        <SiteSearchingResult
                            :tag="result.section"
                            :href="result.url"
                            :title="result.title"
                            :description="result.excerpt"
                            :filename="result.filename" />
                    </template>
                </div>

                <template v-if="pageTotalSize > currentPage">
                    <div class="nyk-site-searching__content__list__action">
                        <button v-on:click="getMoreResults" class="nyk-button nyk-button--outline-primary">
                            {{ labels.seeMoreButtonLabel }}
                        </button>
                    </div>
                </template>
            </div>
        </div>
    </article>
</template>
